export interface QuestionOptionDraft {
  label: string;
  content: string;
  is_correct: boolean;
}

const OPTION_LABELS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const QUESTION_TYPE_OPTIONS = [
  { value: 'single_choice', label: 'Opción única' },
  { value: 'multiple_choice', label: 'Opción múltiple' },
  { value: 'true_false', label: 'Verdadero / Falso' },
  { value: 'short_answer', label: 'Respuesta corta' },
  { value: 'long_answer', label: 'Respuesta larga' },
  { value: 'file_upload', label: 'Subir archivo' },
] as const;

export function hasQuestionOptions(type: string): boolean {
  return ['single_choice', 'multiple_choice', 'true_false', 'short_answer', 'long_answer'].includes(type);
}

export function hasSelectableOptions(type: string): boolean {
  return ['single_choice', 'multiple_choice', 'true_false'].includes(type);
}

export function isSingleCorrectType(type: string): boolean {
  return type === 'single_choice' || type === 'true_false';
}

export function defaultOptionsForType(type: string): QuestionOptionDraft[] {
  if (type === 'true_false') {
    return [
      { label: 'V', content: 'Verdadero', is_correct: true },
      { label: 'F', content: 'Falso', is_correct: false },
    ];
  }

  if (type === 'short_answer' || type === 'long_answer') {
    return [{ label: 'A', content: '', is_correct: true }];
  }

  if (type === 'single_choice' || type === 'multiple_choice') {
    return [
      { label: 'A', content: '', is_correct: true },
      { label: 'B', content: '', is_correct: false },
    ];
  }

  return [];
}

export function reindexOptionLabels(options: QuestionOptionDraft[]): QuestionOptionDraft[] {
  return options.map((opt, index) => ({
    ...opt,
    label: OPTION_LABELS[index] ?? '',
  }));
}

export function addOption(options: QuestionOptionDraft[], isCorrect = false): QuestionOptionDraft[] {
  return [
    ...options,
    {
      label: OPTION_LABELS[options.length] ?? '',
      content: '',
      is_correct: isCorrect,
    },
  ];
}

export function removeOption(
  options: QuestionOptionDraft[],
  index: number,
  minCount = 2,
): QuestionOptionDraft[] {
  if (options.length <= minCount) return options;
  return reindexOptionLabels(options.filter((_, i) => i !== index));
}

export function markCorrectOption(
  options: QuestionOptionDraft[],
  index: number,
  singleCorrect: boolean,
): QuestionOptionDraft[] {
  if (singleCorrect) {
    return options.map((opt, i) => ({ ...opt, is_correct: i === index }));
  }
  return options.map((opt, i) => (i === index ? { ...opt, is_correct: !opt.is_correct } : opt));
}

export function updateOptionContent(
  options: QuestionOptionDraft[],
  index: number,
  content: string,
): QuestionOptionDraft[] {
  return options.map((opt, i) => (i === index ? { ...opt, content } : opt));
}
